import { Link } from "react-router-dom";
import ZeussToken from "../../../../Contract/zeussToken.json";
const TribeAddress = () => {
  const address = ZeussToken.address;
  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(address)
      .then(() => alert("Address copied to clipboard!"))
      .catch((err) => console.error("Failed to copy:", err));
  };
  return (
    <>
      <section className="TribeAddress py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="TribeAddressDiv">
                <div className="title">
                  <h4>$ZFORGE ERC20 Address</h4>
                </div>
                <div className="address">
                  <Link
                    target="_blank"
                    to={`https://etherscan.io/address/${ZeussToken.address}`}
                  >
                    {ZeussToken.address}
                  </Link>
                </div>
                <div className="btn-address">
                  <button onClick={copyToClipboard}>Copy address</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default TribeAddress;
